import { useMemo } from 'react';
import { FormFields } from '../../common/types';
import { useConfig } from '../../hooks/useConfig';
import getI18N from '../../lib/i18n';
import { availableTariffsSelector } from '../../store/form/selectors';
import { useAppSelector } from '../../store/hooks';

const i18n = getI18N();

export const useBadgeTitleOptions = (fields: FormFields) => {
    const { localisation } = useConfig();
    return useMemo(() => {
        const o1 = localisation.optionOrderIn;

        const o2 = localisation.optionGetRide;

        const o3 = i18n('Доехать на такси');
        return [
            { text: o1, value: o1 },
            { text: o2, value: o2 },
            { text: o3, value: o3 },
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n, fields.lang, fields.app]);
};

export const useTariffOptions = () => {
    const availableTariffs = useAppSelector(availableTariffsSelector);

    const tariffNames = {
        econom: i18n('Эконом'),
        business: i18n('Комфорт'),
        minivan: i18n('Минивен'),
        vip: i18n('Бизнес'),
        express: i18n('Доставка'),
    };
    const options = [];
    for (let i = 0; i < availableTariffs.length; i += 1) {
        const value = availableTariffs[i];
        const text = tariffNames[value];
        const option = { text, value };
        options.push(option);
    }
    return options;
};

export const useRouteTypeOptions = () => {
    const options = [
        { label: i18n('Куда'), value: 'to' },
        { label: i18n('Откуда'), value: 'from' },
        { label: i18n('Без адреса'), value: 'none' },
    ];
    return options;
};

export const useSubtitleOptions = () => {
    const options = [
        { label: i18n('Указанный адрес'), value: 'address' },
        { label: i18n('Цена'), value: 'price' },
    ];
    return options;
};
